import { render, staticRenderFns } from "./LogoGifteryBelarus.vue?vue&type=template&id=7eca3953&scoped=true&"
import script from "./LogoGifteryBelarus.vue?vue&type=script&lang=js&"
export * from "./LogoGifteryBelarus.vue?vue&type=script&lang=js&"
import style0 from "./LogoGifteryBelarus.vue?vue&type=style&index=0&id=7eca3953&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eca3953",
  null
  
)

export default component.exports